<template>
  <article v-if="showCard" class="ut-card-base ut-mb-5 ut-p-0 ut-cursor-pointer"
    v-gaEvent="{ category: gacategory, action: gaaction }">
    <prospect-card-header :address="contactPropertyAddress"
      @click.native="navigateToProspect(prospect.key)"
      :consultantName="consultantInfo.name"
      :prospectKey="prospect.key" />
    <hr class="ut-opacity-25 ut-text-neutral-200"/>
    <prospect-card-details :prospectName="prospectFullName"
      @click.native="navigateToProspect(prospect.key)"
      :activitySummary="topActivitySummary"
      :prospectDate="prospectDate" />
    <hr class="ut-opacity-25 ut-text-neutral-200"/>
    <div id="prospect-card-bottom"
      class="sm:ut-flex md:ut-justify-between sm:ut-pr-8 ut-py-6"
      @click.self="navigateToProspect(prospect.key)">
      <div class="ut-ml-0 md:ut-px-0 ut-px-6">
        <pill v-if="prospectStageBadge"
              class="ut-mr-2 ut-text-sm"
              :happy="!hasNotAttempted"
              :danger="hasNotAttempted">
              {{ prospectStageBadge }}
        </pill>
        <pill v-if="prospectActionBadge"
              class="ut-text-sm">
              {{ prospectActionBadge }}
        </pill>
      </div>
      <hr class="ut-opacity-25 ut-text-neutral-200 ut-my-6 sm:ut-hidden"/>
      <div class="ut-mr-0 ut-flex ut-justify-between ut-content-center sm:ut-px-0 ut-px-6">
        <button class="btn btn-green ut-mr-2 sm:ut-w-32 ut-w-full"
        @click="navigateToProspect(prospect.key)">View</button>
        <button class="btn btn-green-inverted ut-p-0 ut-w-10 ut-h-10 ut-flex-shrink-0"
            title="Archive"
            @click="showModal('prospecting-remove-prospect-modal', removeProspectData)"
            v-gaEvent="{ category: gacategory, action: gaaction }">
          <svg-loader :name="'icon-trash'" :width="24" />
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import ProspectingHelpers from '@/helpers/prospecting-helpers';
import Pill from '@/components/Pill.vue';
import ProspectStageType from '@/Mapper/ProspectStageType';
import {
  ProspectActivityActionTypeId,
} from '@/Mapper/ProspectActivityActionType';

import ProspectCardHeader from '@/components/ProspectCardHeader.vue';
import ProspectCardDetails from '@/components/ProspectCardDetails.vue';

export default {
  name: 'ProspectCard',
  components: {
    Pill,
    SvgLoader,
    ProspectCardHeader,
    ProspectCardDetails,
  },
  props: {
    prospect: {
      type: Object,
      required: false,
    },
    filterOption: {
      required: false,
      default: null,
    },
    gacategory: {
      type: String,
      required: false,
    },
    gaaction: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    topActivity() {
      return ProspectingHelpers.getProspectsTopActivity(this.prospect.activities);
    },
    consultantInfo() {
      const data = {
        name: null,
        img: null,
      };

      if (ProspectingHelpers.isOaAssistantActivity(this.topActivity)) {
        data.name = 'Phone verified ';
      }

      return data;
    },
    activteReminder() {
      return ProspectingHelpers.getProspectsActivteReminder(this.prospect.reminders);
    },
    topActivitySummary() {
      return ProspectingHelpers.getPropsectActivitySummary(this.topActivity);
    },
    contactPropertyAddress() {
      if (this.topActivity && this.topActivity.contactPropertyAddress) {
        return this.$options.filters.address(this.topActivity.contactPropertyAddress, true) || null;
      }

      if (this.topActivity
        && this.topActivity.actionType.activityActionTypeId === ProspectActivityActionTypeId.oaMatch
        && !this.topActivity.contactPropertyAddress) {
        return 'Active near your agency';
      }

      return null;
    },
    hasNotAttempted() {
      return ProspectingHelpers.hasNotAttempted(this.prospect.stage);
    },
    prospectDate() {
      // date the contact became a new prospect
      const newStage = this.prospect.stages
        .find(stage => stage.stageType.stageTypeId === ProspectStageType.new);

      if(!newStage) return null;
      
      const convertDate = this.$helpers.convertFromUTC(newStage.createdDate, 'D MMM YYYY');

      return newStage ? `${this.$options.filters.calcDaysAgo(convertDate)}` : null;
    },
    prospectFullName() {
      return `${this.prospect.contact.firstName}${this.prospect.contact.lastName ? ` ${this.prospect.contact.lastName}` : ''}`;
    },
    prospectStageBadge() {
      return ProspectingHelpers.getProspectStageBadge(this.prospect);
    },
    prospectActionBadge() {
      return ProspectingHelpers.getProspectActionBadge(this.prospect, this.activteReminder);
    },
    removeProspectData() {
      return {
        prospect: this.prospect,
        topActivity: this.topActivity,
      };
    },
    showCard() {
      if (this.filterOption) {
        if (this.filterOption === 'all') {
          return true;
        }

        if (`${this.prospect.stage.stageType.stageTypeId}-stage` === this.filterOption) {
          return true;
        }

        if (this.activteReminder && `${this.activteReminder.reminderType.reminderTypeId}-reminder` === this.filterOption) {
          return true;
        }

        return false;
      }

      return true;
    },
  },
  watch: {},
  created() {
    this.prospect.activities.sort((a, b) => new Date(b.activityDate) - new Date(a.activityDate));
  },
  methods: {
    showModal(name, data) {
      this.$modal.show(name, data);
    },
    navigateToProspect(prospectKey, contactKey) {
      console.log(this.$route.meta.gaPageView);
       
      this.$router.push({
        path: `/${this.$route.params.ak}/prospect/${prospectKey}`,
        params: { ak: this.$route.params.ak, ck: contactKey, pk: prospectKey },
        hash: this.$route.hash,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  #prospect-card-bottom {
    @screen md {
      padding-left: 72px;
    }
  }

  .ut-card-base {
    border-radius: 0;

    @screen sm {
      border-radius: 4px;
    }
  }
</style>
